export const themeColors = ['purple', 'gray_blue', 'orange', 'lilac'] as const
